/*
 * @Author: Json Chen
 * @Date: 2021-06-28 10:00:19
 * @LastEditTime: 2022-06-02 14:28:33
 * @LastEditors: Json Chen
 * @Description: PriceTier 的列表展示,外层以 Form.Item 包裹,整个数组作为 value
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/PriceTierTable.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import ModalDelHOC from '@/src/constrains/ModalDelHOC';
import React from 'react';
import styles from '../style.module.less';
import PriceTierModalForm from './PriceTierModalForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TIPCONTENTSTRATEGY = ({ getI18n }) => ({
  confirm: {
    title: getI18n('storeProductSetting.detail.deletePriceTier'),
    content: getI18n('storeProductSetting.detail.deletePriceTierContent'),
    buttonType: 'primary',
    okText: getI18n('general.confirm'),
  },
  delete: {
    title: getI18n('storeProductSetting.detail.deletePriceTier'),
    content: getI18n('storeProductSetting.detail.deletePriceTierContent2'),
    buttonType: 'danger',
    okText: getI18n('general.delete'),
  },
});

const PriceTierTable = ({
  value: priceTierList = [],
  onChange,
  priceTierDefaultCurrency,
  priceTierCurrencyOptions,
  onDelClick,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [priceTierModalVisible, setAddPriceTierModalVisible] =
    React.useState<boolean>(false);
  const showAddPriceTierModal = () => {
    setAddPriceTierModalVisible(true);
  };
  const [priceTierIndex, setPriceTierIndex] = React.useState<number>(-1);
  const onPriceTierActionEditClick = (column, index) => {
    setPriceTierIndex(index);
    setAddPriceTierModalVisible(true);
  };
  const hideAddPriceTierModal = () => {
    setAddPriceTierModalVisible(false);
    setPriceTierIndex(-1);
  };

  const onConfirm = (values) => {
    if (priceTierIndex === -1) {
      // Add
      onChange(priceTierList.concat({ ...values, deletable: true }));
    } else {
      onChange(
        priceTierList.map((item, index) => {
          return index === priceTierIndex ? { ...item, ...values } : item;
        }),
      );
    }
    hideAddPriceTierModal();
  };
  const priceTierColumns = [
    {
      title: getI18n('storeProductSetting.detail.priceTier'),
      key: 'index',
      dataIndex: 'index',
      default: true,
      width: 90,
      childGenerate: (_, record, index) => {
        return <div className={styles.tb}>{index + 1}.</div>;
      },
    },
    {
      title: getI18n('storeProductSetting.detail.priceTierTitle'),
      dataIndex: 'title',
      key: 'title',
      default: true,
      width: 352,
      textWrap: 'word-break',
      childGenerate: (text: string) => {
        return <div className={styles.tb}>{text}</div>;
      },
    },
    {
      title: getI18n('storeProductSetting.detail.priceTierCurrency'),
      key: 'currencyCode',
      dataIndex: 'currencyCode',
      default: true,
      width: 192,
      textWrap: 'word-break',
      childGenerate: (text: string) => {
        return <div className={styles.tb}>{text}</div>;
      },
    },
    {
      title: getI18n('storeProductSetting.detail.priceTierRemarks'),
      key: 'remarks',
      dataIndex: 'remarks',
      default: true,
      width: 320,
      textWrap: 'word-break',
      childGenerate: (text: string) => {
        return <div className={styles.tb}>{text}</div>;
      },
    },
    disabled
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          default: true,
          optional: true,
          align: 'center',
          width: 128,
          childGenerate: (_, record, index) => {
            return (
              <div className={styles.action}>
                <span
                  className={styles.primary}
                  onClick={() => onPriceTierActionEditClick(record, index)}>
                  {getI18n('general.edit')}
                </span>
                <span
                  className={styles.danger}
                  onClick={() => onDelClick(index)}>
                  {getI18n('general.delete')}
                </span>
              </div>
            );
          },
        },
  ];
  return (
    <>
      {priceTierList.length ? (
        <SizeFittingTable
          rowKey='title'
          pagination={false}
          id='StoreSettingsProductPriceTier'
          className={styles.table}
          dataSource={priceTierList}
          columns={priceTierColumns}
        />
      ) : (
        <div className={styles.noresult}>
          {getI18n('storeProductSetting.detail.noproductpricetier')}
        </div>
      )}
      <Button
        type='primary'
        //  htmlType='button'
        onClick={showAddPriceTierModal}
        disabled={disabled}>
        {getI18n('storeProductSetting.detail.addPriceTier')}
      </Button>
      <PriceTierModalForm
        visible={priceTierModalVisible}
        onConfirm={onConfirm}
        onCancel={hideAddPriceTierModal}
        priceTierDefaultCurrency={priceTierDefaultCurrency}
        priceTierCurrencyOptions={priceTierCurrencyOptions}
        priceTierList={priceTierList}
        priceTierIndex={priceTierIndex}
      />
    </>
  );
};

export default ModalDelHOC(PriceTierTable, {
  modalDataStrategy: TIPCONTENTSTRATEGY,
  canDel: ({ list, index }) => {
    // 返回true,则可以被删除,否则不能被删除
    return list[index].deletable;
  },
});
